<template>
	<component is="style">
		:root {
		--primary-color: {{ vars.primaryColor }};
		--secondary-color: {{ vars.secondaryColor }};
		--background-color: {{ vars.backgroundColor }};
		--button-color: {{ vars.buttonColor }};
		--aside-background-color: {{ vars.asideBackgroundColor }};
		--dark-background-color: {{ vars.darkBackgroundColor }};
		--end-gradient-color: {{ vars.endGradientColor}};
		--white-color: {{ vars.whiteColor }};
		--black-color: {{ vars.blackColor }};
		--font-color: {{ vars.fontColor }};
		--secondary-font-color: {{ vars.secondaryFontColor }};
		--footer-color: {{ vars.footerColor }};
		--auth-popup-color: {{ vars.authPopupColor }};

		--background-color-rgb: {{ vars.backgroundColorRgb }};
		--dark-background-color-rgb: {{ vars.darkBackgroundColorRgb }};
		--white-color-rgb: {{ vars.whiteColorRgb }};
		--black-color-rgb: {{ vars.blackColorRgb }};
		--primary-color-rgb: {{ vars.primaryColorRgb }};

		--primary-gradient: {{ vars.primaryGradient }};
		--safe-area-top: {{ safeAreaTop }}px;
		--safe-area-bottom: {{ safeAreaBottom }}px;
		}
	</component>
</template>

<script>
	import pageFunctionsMixin from '../../mixins/pageFunctionsMixin';

	export default {
		name: "CssVariables",
		mixins: [pageFunctionsMixin],
		computed: {
			safeAreaTop(){
				return this.$store.state.app.safeArea.top;
			},
			safeAreaBottom(){
				return this.$store.state.app.safeArea.bottom;
			},
			brokerData(){
				if (!this.$store.state.auth.user.agent) {
					return false;
				}

				if (!this.$store.state.auth.user.agent.broker_data) {
					return false;
				}

				return this.$store.state.auth.user.agent.broker_data;
			},
			brokerId() {
				if (!this.$store.state.auth.user.agent) {
					return 1;
				}

				if (!this.$store.state.auth.user.agent.broker_data) {
					return 1;
				}

				return this.$store.state.auth.user.agent.broker_data.broker_id;
			},
			pluskaVars() {
				let vars = {
					primaryColor: '#FFCF28',
					secondaryColor: '#7F8994',
					backgroundColor: '#141412',
					buttonColor: '#ffffff',
					asideBackgroundColor: '#141412',
					lightBackgroundColor: '#1d2943',
					darkBackgroundColor: '#000000',
					endGradientColor: '#F0A21B',
					whiteColor: '#ffffff',
					blackColor: '#000000',
					fontColor: 'rgba(var(--white-color-rgb), .5)',
					secondaryFontColor: '#808795',
					footerColor: '#ffffff',
					authPopupColor: '#020202',

					primaryColorRgb: '255, 207, 40',
					backgroundColorRgb: '20, 20, 18',
					darkBackgroundColorRgb: '0, 0, 0',
					whiteColorRgb: '255, 255, 255',
					blackColorRgb: '0, 0, 0',

					primaryGradient: 'linear-gradient(to right, var(--primary-color) 0%, var(--end-gradient-color) 100%)',
				};

				return vars;
			},
			isanonVars() {
				let vars = {
					primaryColor: '#f9a03a',
					secondaryColor: 'var(--primary-color)',
					backgroundColor: '#000E2A',
					buttonColor: '#ffffff',
					asideBackgroundColor: '#0F1C37',
					lightBackgroundColor: '#1d2943',
					darkBackgroundColor: '#000C23;',
					endGradientColor: '#ee4a38',
					whiteColor: '#ffffff',
					blackColor: '#000000',
					fontColor: 'rgba(var(--white-color-rgb), .5)',
					secondaryFontColor: '#808795',
					footerColor: '#f6f9ff',
					authPopupColor: '#000715',

					primaryColorRgb: '245, 130, 32',
					backgroundColorRgb: '0, 14, 42',
					darkBackgroundColorRgb: '0, 12, 35',
					whiteColorRgb: '255, 255, 255',
					blackColorRgb: '0, 0, 0',

					primaryGradient: 'linear-gradient(to right, var(--primary-color) 0%, var(--end-gradient-color) 100%)',
				};

				return vars;
			},
			vars() {
				if (this.$store.state.app.appType === 'pluska') {
					return this.pluskaVars;
				}

				let defaultVars = this.isanonVars;

				if (!this.brokerData){
					return defaultVars;
				}

				let defaultAlliances = [
					'universal',
					'universal_dev',
					'umd',
					'umd_dev',
				];

				if (!this.brokerData || (parseInt(this.brokerId) === 1) && defaultAlliances.includes(this.$store.state.auth.user.alliance)){
					return defaultVars;
				}

				let vars = this.isanonVars;

				if(this.brokerData.colors_ufo
					&& this.brokerData.colors_ufo.primary
					&& this.brokerData.colors_ufo.secondary
					&& this.brokerData.colors_ufo.third
					&& this.brokerData.colors_ufo.fourth){
					let rgb = this.hexToRgb(this.brokerData.colors_ufo.primary);
					vars.primaryColor = this.brokerData.colors_ufo.primary;
					vars.secondaryColor = this.brokerData.colors_ufo.secondary;
					vars.backgroundColor = this.brokerData.colors_ufo.third;
					vars.endGradientColor = this.brokerData.colors_ufo.fourth;
					vars.primaryColorRgb = rgb;
					vars.asideBackgroundColor = 'var(--background-color)';

					let colorStyle = this.getColorStyle(this.brokerData.colors_ufo.primary);
					if(colorStyle === 'light'){
						vars.buttonColor = '#000000';
					}
				}

				return vars;
			}
		},
		methods: {
			hexToRgb(hex) {
				let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result.join(',');
			}
		}
	}
</script>

<style scoped>

</style>